import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import NumberInput from '../../Common/numberInput';
import Validator from '../../Common/validator';
import { isStringValid } from '../../Util/stringValidator';
import ThirdActivity from './thirdActivity';

class SecondActivity extends Component {
  shouldComponentUpdate = (nextProps) => {
    // eslint-disable-next-line
    if (nextProps.rowShouldUpdate.secondKey == this.props.index || nextProps.rowShouldUpdate.secondKey == 0) {
      return true
    }
    return false;
  };
  componentWillMount = () => {
    //if root activty dont have children add a child
    // eslint-disable-next-line
    if (this.props.second.thirds.length == 0 && (!this.props.isEdit || !this.props.second.name.initialValue)) {
      this.props.second.thirds.addField();
    }
    // eslint-disable-next-line
    if (this.props.secondActivityCount == this.props.index && this.props.second.name.value) {
      this.props.addNewField()
    }
  };
  onChangeWrap = (evt, inputTarget) => {
    this.props.setRowShouldUpdate();
    inputTarget.onChange(evt);
  };
  onBlurWrap = (evt, inputTarget) => {
    this.props.setRowShouldUpdate();
    inputTarget.onBlur(evt);
  };
  addThird = () => {
    this.props.second.thirds.addField();
  };
  calcSumField = (val1, val2) => {
    const { second } = this.props;
    if ((!val1 && val1 !== 0) || (!val2 && val2 !== 0)) {
      second.sum.onChange(null);
    }
    else {
      let roundedNumber = Math.round(val1 * val2 * 10) / 10;
      second.sum.onChange(roundedNumber);
    }

  };
  render() {
    const { styles, second, rootKey, index, setRowShouldUpdate, rowShouldUpdate, isEdit } = this.props;
    let indexKey = rootKey + "." + index;
    var shouldRenderSelf = true;
    var thirdsSum = 0;
    var thirdActivities = []
    second.thirds.forEach((third, i) => {
      //if any values on the third it should not render self
      if (isStringValid(third.name.value) ||
        isStringValid(third.unit.value) ||
        third.amount.value ||
        // eslint-disable-next-line
        third.amount.value == 0 ||
        third.hoursPerUnit.value ||
        // eslint-disable-next-line
        third.hoursPerUnit.value == 0 ||
        third.sum.value ||
        // eslint-disable-next-line
        third.sum.value == 0) {
        shouldRenderSelf = false;
      }
      //calculate total sum of thirds
      if (third.sum.value)
        thirdsSum += third.sum.value;

      //push the third into thirdsArray
      thirdActivities.push(
        <ThirdActivity
          key={i}
          styles={styles}
          rootKey={rootKey}
          secondKey={index}
          index={i + 1}
          third={third}
          setRowShouldUpdate={() => setRowShouldUpdate(i + 1)}
          rowShouldUpdate={rowShouldUpdate}
          // eslint-disable-next-line
          addNewField={i + 1 == second.thirds.length ? this.addThird : null}
          thirdActivityCount={second.thirds.length}
          isEdit={isEdit}
        />)
    });

    return (
      (
        <div key={indexKey}>
          <div className="row" style={styles.activityContainer}>
            <div style={[styles.firstInSecondRow]} className={second.name.valid ? "col-sm-4" : "col-sm-4 error"} >
              <div style={[styles.indexKey, styles.indexKeySecond]}>{indexKey}</div>
              <Validator
                isValid={!second.name.touched || second.name.valid}>
                <input
                  className="form-control"
                  type="text"
                  value={second.name.value ? second.name.value : ''}
                  placeholder={!(!second.name.touched || second.name.valid) ? second.name.error : second.name.initialValue ? second.name.initialValue : "Aktivitet"}
                  style={[styles.secondInputField, styles.inputField, styles.inputFieldName]}
                  onBlur={(evt) => {
                    // eslint-disable-next-line
                    if (evt.target.value == "" && second.name.initialValue && isEdit) {
                      evt.target.value = second.name.initialValue
                    }
                    this.onBlurWrap(evt, second.name)
                  }}
                  onChange={(evt) => {
                    this.onChangeWrap(evt, second.name)
                    // if addNewField is a fucntion, then add new field
                    if (this.props.addNewField) this.props.addNewField();
                  }}
                />
              </Validator>
            </div>
            {shouldRenderSelf ? (
              <div>
                <div className={second.unit.valid ? "col-sm-2" : "col-sm-2 error"} style={styles.col}>
                  <Validator
                    isValid={!second.unit.touched || second.unit.valid}>
                    <input
                      className="form-control"
                      type="text"
                      value={second.unit.value}
                      placeholder={!(!second.unit.touched || second.unit.valid) ? second.unit.error : "Enh"}
                      style={[styles.secondInputField, styles.inputField]}
                      onBlur={(evt) => { this.onBlurWrap(evt, second.unit) }}
                      onChange={(evt) => { this.onChangeWrap(evt, second.unit) }} />
                  </Validator>
                </div>
                <div className={second.amount.valid ? "col-sm-2" : "col-sm-2 error"} style={styles.col}>
                  <Validator
                    isValid={!second.amount.touched || second.amount.valid}>
                    <NumberInput
                      disableClearOnEnter={true}
                      style={[styles.secondInputField, styles.inputField]}
                      placeHolder={!(!second.amount.touched || second.amount.valid) ? second.amount.error : "Mgd"}
                      {...second.amount}
                      onBlur={(evt) => {

                        this.onBlurWrap(evt, second.amount)
                      }}
                      onChange={(evt) => {
                        this.calcSumField(evt, second.hoursPerUnit.value);
                        this.onChangeWrap(evt, second.amount)
                      }}
                    />
                  </Validator>
                </div>
                <div className={second.hoursPerUnit.valid ? "col-sm-2" : "col-sm-2 error"} style={styles.col}>
                  <Validator
                    isValid={!second.hoursPerUnit.touched || second.hoursPerUnit.valid}>
                    <NumberInput
                      disableClearOnEnter={true}
                      style={[styles.secondInputField, styles.inputField]}
                      placeHolder={!(!second.hoursPerUnit.touched || second.hoursPerUnit.valid) ? second.hoursPerUnit.error : "Timer/enh"}
                      {...second.hoursPerUnit}
                      onBlur={(evt) => {

                        this.onBlurWrap(evt, second.hoursPerUnit)
                      }}
                      onChange={(evt) => {
                        this.calcSumField(evt, second.amount.value);
                        this.onChangeWrap(evt, second.hoursPerUnit)
                      }}
                    />
                  </Validator>
                </div>
                <div className="col-sm-2" style={styles.col}>
                  <input
                    className="form-control"
                    type="text"
                    disabled={true}
                    value={second.sum.value ? second.sum.value : ''}
                    placeholder="Sum"
                    style={[styles.secondInputField, styles.inputField]}
                  />
                </div>
              </div>)
              : <div style={styles.thirdsSum}>{thirdsSum}</div>}
          </div>
          {thirdActivities}
        </div>
      )
    );
  }
}

SecondActivity.propTypes = {
  second: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  rootKey: PropTypes.number.isRequired,
  setRowShouldUpdate: PropTypes.func.isRequired,
  rowShouldUpdate: PropTypes.object.isRequired,
  addNewField: PropTypes.func,
  secondActivityCount: PropTypes.number.isRequired,
  isEdit: PropTypes.bool.isRequired
};

export default Radium(SecondActivity)


// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/secondActivity.jsx